import React from "react";
var __jsx = React.createElement;
import { useMemo } from "react";
import { useLang } from "@/common/Contexts/LanguageContext";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
var FlowScreenBodySpacing = function FlowScreenBodySpacing(_ref) {
  var children = _ref.children;
  var lang = useLang();
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state;
  var maxHeight = useMemo(function () {
    if (__IS_SSR__) {
      return "fit-content";
    }
    if (state !== null && state !== void 0 && state.haveSelection) {
      var _window;
      return ((_window = window) === null || _window === void 0 ? void 0 : _window.innerHeight) - 186 - 106 + "px";
    }
    return window.innerHeight - 160 - 106 + "px";
  }, [state === null || state === void 0 ? void 0 : state.haveSelection]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 overflow-y-auto px-4 pb-4 md:max-h-[485px] my-scroll",
    dir: lang == 'ar' ? 'ltr' : "rtl",
    style: {
      maxHeight: maxHeight
    }
  }, children));
};
export default FlowScreenBodySpacing;